import * as S from "./Charts.style";

interface ChartsProps {
  title?: string;
  children?: React.ReactNode;
}

export const Charts = ({ title, children }: ChartsProps) => {
  return (
    <S.Charts>
      {title && <S.ChartTit>{title}</S.ChartTit>}
      {children}
    </S.Charts>
  );
};
